import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import {
  useTransition,
  animated,
  config as springConfig
} from '@react-spring/web'
import { CopyToClipboardUrl } from 'components/copyToClipboardUrl'
import { ArticleTeaser } from 'components/articleLink'
import { Vote } from 'components/vote'
import { FlagButton } from 'components/flagButton'
import stylesSheet from './infoLayer.m.scss'
import { Marker } from 'mapbox-gl'
// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import fr from 'locales/fr.yaml'

const localisationStrings = { fr }
const isMobile = window.innerWidth < 768

export const InfoLayer = ({
  data,
  locale,
  userId,
  articleId
}: {
  data: Marker[]
  locale: string
  userId: string | null
  articleId: number
}) => {
  const location = useLocation()
  const history = useHistory()

  const [selectedPlace, setselectedPlace] = useState()
  const [showInfoLayer, setShowInfoLayer] = useState(false)
  const infoLayer = useRef(null)

  const handleExit = () => {
    history.replace('/')
  }

  const transitions = useTransition(showInfoLayer, {
    config: springConfig.stiff,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    onRest: () => {
      if (location.pathname.split('/')[1] === 'buvette') {
        document.body.classList.add('freeze')
        // infoLayer.current.scrollY = 0
        // disableBodyScroll(infoLayer.current, {
        //   reserveScrollBarGap: true
        // })
      } else {
        document.body.classList.remove('freeze')
        // enableBodyScroll(infoLayer.current)
      }
    }
  })

  useEffect(() => {
    if (data) {
      const restaurant = data
        ? data.find(c => c.markerId === location.pathname.split('/')[2])
        : null

      if (location.pathname.split('/')[1] === 'buvette') {
        setselectedPlace(restaurant)
      } else {
        setShowInfoLayer(false)
      }

      if (restaurant) {
        setShowInfoLayer(true)
        window.scrollTo(
          0,
          document.getElementById('map-container').getBoundingClientRect().top +
            window.scrollY
        )
      }
    }
  }, [location.pathname, data])

  useEffect(() => {
    return () => {
      document.body.classList.remove('freeze')
    }
  }, [])

  const nextCandidate = selectedPlace
    ? data[
        (data.findIndex(c => c.markerId === selectedPlace.markerId) + 1) %
          data.length
      ]
    : null

  return transitions(
    (styles, item) =>
      item && (
        <>
          {/* <animated.div
            className={stylesSheet.dimmer}
            onClick={() => {
              handleExit()
            }}
            style={styles}
          /> */}

          <animated.div
            ref={infoLayer}
            className={stylesSheet.infoLayer}
            style={{
              transform: styles.opacity.to(
                v => 'translate3d(0,' + (1 - v) * 100 + '%,0)'
              )
            }}
          >
            {selectedPlace && (
              <div className={stylesSheet.menu}>
                {/* <img
                    onClick={() => {
                      history.replace(`${nextCandidate.id}`)
                    }}
                    className={stylesSheet.nextCandidatePicture}
                    src={require(`../candidats-cards/candidats-pictures/${nextCandidate.id}.jpg`)}
                  /> */}
                <div
                  className={stylesSheet.menuInfos}
                  // onClick={() => {
                  //   history.replace(`${nextCandidate.id}`)
                  // }}
                >
                  <div>{isMobile ? 'Détails' : 'Cette buvette en détail'}</div>
                  <div className={stylesSheet.menuName}>
                    {nextCandidate?.nom}
                  </div>
                  {/* <div className={stylesSheet.link}>
                    Plus d'infos{' '}
                    <i
                      style={{ fontSize: '0.65em' }}
                      className='ui icon chevron right'
                    />
                  </div> */}
                </div>
                <div
                  onClick={() => {
                    handleExit()
                  }}
                  className={stylesSheet.closeBtnMenu}
                >
                  <div className={stylesSheet.close} />
                </div>
              </div>
            )}

            <div className='ui vertical fitted segment info-footer'>
              <div
                className={`ta text special container ${stylesSheet.textContainer}`}
              >
                {selectedPlace && (
                  <div>
                    <div className={stylesSheet.name}>
                      {selectedPlace.title}
                    </div>
                    {selectedPlace.editorsPick && (
                      <div className={stylesSheet.editorsPick}>
                        <i className='ui icon heart' /> Choix de la rédaction
                      </div>
                    )}
                    <div className={stylesSheet.infos}>
                      {selectedPlace.picture && (
                        <img
                          src={`https://interactif.24heures.ch/2022/buvettes-estivales/pictures/${selectedPlace.picture}.jpg`}
                        />
                      )}
                      <div className={`${stylesSheet.description}`}>
                        <p>{selectedPlace.description}</p>
                        {selectedPlace.articleId && (
                          <p>
                            Lire à ce sujet:{' '}
                            <a
                              target='_blank'
                              href={`https://www.24heures.ch/${selectedPlace.articleId}`}
                              rel='noreferrer'
                            >
                              Lausanne garnit ses rives de trois buvettes et
                              d’un coin baignade
                            </a>
                          </p>
                        )}
                      </div>
                      <hr className={stylesSheet.bar} />
                      <div className={stylesSheet.moreInfos}>
                        {selectedPlace.address && (
                          <div>{selectedPlace.address}</div>
                        )}
                        <div>
                          {selectedPlace.website && (
                            <>
                              <a
                                target='_blank'
                                href={selectedPlace.website}
                                rel='noreferrer'
                              >
                                {selectedPlace.website
                                  .replace('https://', '')
                                  .replace(/\/\s{0,1}$/, '')}
                              </a>
                              <br />
                            </>
                          )}
                          {selectedPlace.facebook && (
                            <>
                              <a
                                target='_blank'
                                href={selectedPlace.facebook}
                                rel='noreferrer'
                              >
                                Facebook
                              </a>
                              <br />
                            </>
                          )}
                          {selectedPlace.instagram && (
                            <a
                              target='_blank'
                              href={selectedPlace.instagram}
                              rel='noreferrer'
                            >
                              Instagram
                            </a>
                          )}
                        </div>
                        <div>
                          proposé par <b>{selectedPlace.nickname}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <Vote
              articleId={articleId}
              userId={userId}
              locale='fr'
              itemId={selectedPlace.markerId}
            />

            <div
              className='ui vertical fitted segment'
              style={{
                padding: '0',
                borderTop: '1px solid #f1f1f1',
                borderBottom: '1px solid #f1f1f1'
              }}
            >
              <div
                className={`ta text special container ${stylesSheet.textContainer}`}
                style={{ fontFamily: 'TamediaChart' }}
              >
                <div className={stylesSheet.filtersGroup}>
                  {selectedPlace &&
                    selectedPlace.filters
                      .filter(
                        filter =>
                          filter.value === true && filter.type === 'mainFilters'
                      )
                      .map(filter => (
                        <div
                          className={stylesSheet.inlineFilter}
                          key={`filter-${filter.name}`}
                        >
                          {localisationStrings[locale][filter.name]}
                        </div>
                      ))}
                </div>
                {selectedPlace &&
                  selectedPlace.filters.filter(
                    filter => filter.value === true && filter.type === 'access'
                  ).length > 0 && (
                    <div className={stylesSheet.filtersGroup}>
                      <div className={stylesSheet.filtersGroupTitle}>
                        <b>Accès</b>
                      </div>
                      {selectedPlace.filters
                        .filter(
                          filter =>
                            filter.value === 1 && filter.type === 'access'
                        )
                        .map(filter => (
                          <div
                            className={stylesSheet.inlineFilter}
                            key={`filter-${filter.name}`}
                          >
                            {localisationStrings[locale][filter.name]}
                          </div>
                        ))}
                    </div>
                  )}
              </div>
            </div>

            <div
              style={{
                borderTop: '1px solid #ffffff33',
                borderBottom: '1px solid #ffffff33'
              }}
              className={`ta text special container ${stylesSheet.textContainer}`}
            >
              <div className='ui vertical fitted segment'>
                <CopyToClipboardUrl
                  locale='fr'
                  title='Partager ce contenu'
                  text='Partagez ce restaurant avec vos amis et vos connaissances!'
                  url={window.location.href}
                  buttonColor='#009688'
                />
              </div>
            </div>

            {selectedPlace &&
              selectedPlace.articles &&
              selectedPlace.articles.length > 0 && (
                <div className='ui vertical fitted segment info-footer'>
                  <div
                    className={`ta text special container ${stylesSheet.textContainer}`}
                  >
                    <ArticleTeaser
                      title='À lire aussi'
                      color='#009688'
                      ids={selectedPlace.articles}
                    />
                  </div>
                </div>
              )}

            <div
              className='ui vertical fitted segment'
              style={{ borderTop: '1px solid #f1f1f1' }}
            >
              <div
                className={`ta text special container ${stylesSheet.textContainer}`}
              >
                <div className={stylesSheet.footer}>
                  <button
                    className='ui basic icon labeled small button'
                    onClick={() => {
                      history.replace('/contribuer')
                    }}
                  >
                    <i className='icon pencil alternate' />
                    Proposer une mise à jour
                  </button>
                  <FlagButton
                    userId={userId}
                    markerId={selectedPlace.markerId}
                    articleId={articleId}
                  />
                </div>
              </div>
            </div>
          </animated.div>
        </>
      )
  )
}
